<template>
  <b-card no-body>
    <b-card-body class="text-right">
      <b-button
        variant="primary"
        :to="$route.path + '/add'"
      >
        <FeatherIcon icon="PlusIcon" /> {{ $t('common.create') }}
      </b-button>
    </b-card-body>
    <b-table
      responsive="sm"
      :fields="fields"
      :items="dataList"
      striped
      :busy="loading"
      :empty-text="emptyText"
      :show-empty="!!emptyText"
    >
      <template #table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle" />
          <strong class="ml-2">{{ $t('common.loading') }}</strong>
        </div>
      </template>
      <template #cell(control)="data">
        <div class="text-right">
          <list-buttons
            v-if="Number(data.item.id) !== 1"
            :edit-action="$route.path + '/edit/' + data.item.id"
            :delete-action="removeData"
            :data-id="String(data.item.id)"
          />
        </div>
      </template>
    </b-table>
    <b-card-footer>
      <b-pagination
        v-if="dataCounts > perPage"
        v-model="currentPage"
        :total-rows="dataCounts"
        :per-page="perPage"
        first-number
        last-number
        prev-class="prev-item"
        next-class="next-item"
      >
        <template #prev-text>
          <feather-icon
            icon="ChevronLeftIcon"
            size="18"
          />
        </template>
        <template #next-text>
          <feather-icon
            icon="ChevronRightIcon"
            size="18"
          />
        </template>
      </b-pagination>
    </b-card-footer>
  </b-card>
</template>
<script>
import {
  BCard, BCardBody, BTable, BPagination, BButton, BCardFooter, BSpinner,
} from 'bootstrap-vue'
import ListButtons from '@/layouts/components/common/ListButtons.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

const tableName = 'user_types'
export default {
  name: 'Index',
  components: {
    BCard,
    BCardBody,
    BTable,
    BPagination,
    BButton,
    BCardFooter,
    ListButtons,
    BSpinner,
  },
  data() {
    return {
      currentPage: 1,
      perPage: this.$store.state.app.perPage,
      dataQuery: {
        select: [
          `${tableName}.id AS id`,
          `${tableName}.title AS title`,
        ],
        limit: this.$store.state.app.perPage,
        start: 0,
      },
    }
  },
  computed: {
    fields() {
      return [
        {
          key: 'title',
          label: this.$t('fields.title'),
        },
        {
          key: 'control',
          label: '',
          thStyle: { width: '200px' },
        },
      ]
    },
    loading() {
      return this.$store.getters['userTypes/loading']
    },
    emptyText() {
      if (this.loading === true) {
        return this.$t('common.pleaseWait')
      }
      if (this.dataList.length === 0) {
        return this.$t('common.noData')
      }
      return null
    },
    dataList() {
      return this.$store.getters['userTypes/dataList']
    },
    dataCounts() {
      return this.$store.getters['userTypes/dataCounts']
    },
    saveData() {
      return this.$store.getters['userTypes/dataSaveStatus']
    },
  },
  watch: {
    currentPage(val) {
      this.dataQuery.start = (val - 1) * this.$store.state.app.perPage
      this.getDataList()
    },
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: this.$t('common.toast.success'), icon: 'CheckIcon', text: val.message,
        })
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: this.$t('common.toast.error'), icon: 'XIcon', text: val.message,
        })
      }
      this.getDataList()
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('userTypes/getDataList', this.dataQuery)
    },
    removeData(id) {
      this.$swal({
        title: this.$t('alerts.remove.title'),
        text: this.$t('alerts.remove.message'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('alerts.remove.confirm'),
        cancelButtonText: this.$t('alerts.remove.cancel'),
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          // Sonuç saveData izleyicisinden gösterilir; API reddi HTTP 200 + status:false döner.
          this.$store.dispatch('userTypes/removeData', id)
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      })
    },
  },
}
</script>
